import React, { ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { IUserPermissions } from '../../../../store/UserSlice';
import { checkUserPermission } from '../../../../helper';
import { useAppSelector } from '../../../../hooks';
import { getAuthState } from '../../../../store/AuthSlice';

const CheckPermission: React.FC<{
  permission: IUserPermissions;
  redirectPath?: string;
  children: ReactElement;
}> = ({
  permission,
  redirectPath = process.env.PUBLIC_URL,
  children,
}): ReactElement => {
  const authState = useAppSelector(getAuthState);

  if (authState.user && checkUserPermission(authState.user, permission)) {
    return children || <Outlet />;
  }
  return <Navigate to={redirectPath} replace />;
};

export default CheckPermission;
